import { transformResponse, v3Api } from './axios'
import { CSRF, Session } from '../types/auth'

export const getCsrf = (): Promise<CSRF> => transformResponse(v3Api.get('/auth/csrf'))

export const getSession = (): Promise<Session> => transformResponse(v3Api.get('/auth/session'))

export const refreshToken = (csrf: string): Promise<void> =>
  transformResponse(
    v3Api.post('/auth/refresh', null, {
      headers: {
        'x-csrf': csrf,
      },
    }),
  )
